import { BottomSheet, Button, Radio, Typography } from '@bharatpe/bharat-ui';
import React, { useState } from 'react';
import './styles.scss';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

interface Props {
	showComplaintModal: boolean;
	setShowModal: (arg: boolean) => void;
	setSelectedQuery: (arg: string) => void;
	handleModalClose: () => void;
	list: Array<string>;
	handleRegisterComplaint: () => void;
}
const ReasonCodeModal: React.FC<Props> = ({
	setShowModal,
	handleModalClose,
	list,
	setSelectedQuery,
	handleRegisterComplaint,
	showComplaintModal,
}) => {
	const [query, setQuery] = useState<number>(-1);
	const { languageData } = useLanguageConfig();

	const handleQuerySelection = (index: number) => {
		setQuery(index);
		setSelectedQuery(list[index]);
	};
	return (
		<BottomSheet
			visible={showComplaintModal}
			heading={'Raise Complaint'}
			showCloseButton={false}
			rounded={true}
			onClose={handleModalClose}>
			<div>
				<div className="px3">
					{list.map((item: any, index: number) => {
						return (
							<div className="list-item-container flex py1" key={index} onClick={() => handleQuerySelection(index)}>
								<Radio size="medium" checked={query == index} className="p3" />
								<Typography className="Light400 pt3 grey-dark">{item.bank_description}</Typography>
							</div>
						);
					})}
				</div>
				<div className="flex flex-justify m2">
					<Button variant="outlined" className="w-50 m2" onClick={() => setShowModal(false)}>
						{languageData.CANCEL}
					</Button>
					<Button className="w-50 m2" disabled={query < 0} onClick={handleRegisterComplaint}>
						{languageData.CONFIRM}
					</Button>
				</div>
			</div>
		</BottomSheet>
	);
};

export default ReasonCodeModal;
